export default __webpack_public_path__ + "static/media/trustedby2.ee08e2ef.svg";